module.exports = __webpack_public_path__ + "8c0cab044b391b5d02723d93fac0ee68.ttf";